import MaterialTextField from "../../../../__snowpack__/pkg/@mui/material/TextField.js";
import styled from "styled-components";
export const InputContainer = styled(MaterialTextField).withConfig({
  displayName: "inputstyles__InputContainer",
  componentId: "sc-1xtbgel-0"
})([""]);
